import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmOrgUnitVO {
  id?: number
  parentId?: number
  name: string
  code?: string
  sort?: number
  status?: number
  remark?: string
  createTime?: string
  children?: FirmOrgUnitVO[]
}

export interface FirmTeamVO {
  id?: number
  orgUnitId: number
  orgUnitName?: string
  name: string
  code?: string
  leaderLawyerId?: number
  leaderLawyerName?: string
  status?: number
  remark?: string
  createTime?: string
}

export interface FirmTeamPageReqVO extends PageParam {
  orgUnitId?: number
  name?: string
  status?: number
}

export const FirmOrgApi = {
  createOrg: (data: FirmOrgUnitVO) => request.post({ url: '/lawyer/firm/org-unit/create', data }),
  updateOrg: (data: FirmOrgUnitVO) => request.put({ url: '/lawyer/firm/org-unit/update', data }),
  getOrgTree: () => request.get({ url: '/lawyer/firm/org-unit/tree' }),

  createTeam: (data: FirmTeamVO) => request.post({ url: '/lawyer/firm/team/create', data }),
  updateTeam: (data: FirmTeamVO) => request.put({ url: '/lawyer/firm/team/update', data }),
  getTeam: (id: number) => request.get({ url: '/lawyer/firm/team/get', params: { id } }),
  getTeamPage: (params: FirmTeamPageReqVO) =>
    request.get({ url: '/lawyer/firm/team/page', params }) as Promise<PageResult<FirmTeamVO>>,
  updateLawyerPrimaryTeam: (data: { lawyerId: number; primaryTeamId?: number | null; reason?: string }) =>
    request.put({ url: '/lawyer/firm/team/lawyer/primary-team', data })
}
